module.exports = __webpack_public_path__ + "img/cherry.be5030ca.webp";